/* TALISHKO — Cart page premium redesign (reversible).
   Rebuilds the summary column into ONE cohesive "Order summary" card:
   gift-wrap add-on + coupon (with Apply) + labeled totals (discount shown WITH the prices)
   + full-width checkout + trust. Native scattered bits are relocated/hidden. */
(function () {
  if (window.__tlskCartPage) return; window.__tlskCartPage = true;

  var CFG = window.TLSK_CART || {};
  var MONEY = CFG.money || '${{amount}}';
  var FREE_SHIP = CFG.freeShip === true;
  var tmr = null;

  function money(c) {
    var v = (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return MONEY.split('{{amount}}').join(v).split('{{amount_no_decimals}}').join(Math.round(c / 100));
  }
  function setHTML(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }
  function summaryCol() { return document.querySelector('.t4s-cartPage__form .t4s-order-4, .t4s-cartPage__form .t4s-summary-cart'); }

  function discInfo(cart) {
    var a = (cart.cart_level_discount_applications || [])[0];
    if (a) {
      var label = a.value_type === 'percentage' ? (parseFloat(a.value) + '% off') : (money(a.total_allocated_amount) + ' off');
      return { code: a.title, label: label, amt: a.total_allocated_amount };
    }
    var dc = (cart.discount_codes || []).filter(function (d) { return d.applicable; })[0];
    if (dc && cart.total_discount > 0) return { code: dc.code, label: money(cart.total_discount) + ' off', amt: cart.total_discount };
    return null;
  }

  var SVG_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';

  // one-time restructure of the summary column into the premium card
  function buildCard() {
    var col = summaryCol(); if (!col) return null;
    if (col.getAttribute('data-tlsk-built') === '1') return col;
    col.setAttribute('data-tlsk-built', '1');
    col.classList.add('tlsk-summary');

    var frag = document.createElement('div'); frag.className = 'tlsk-summary__inner';

    // heading
    frag.innerHTML = '<div class="tlsk-summary__h">Order summary</div>';

    // gift-wrap add-on (relocate the existing toggle so its change handler keeps working)
    var gw = document.querySelector('.t4s-cartPage__footer .tlsk-gw, .t4s-cartPage__form .tlsk-gw');
    if (gw) { var addon = document.createElement('div'); addon.className = 'tlsk-summary__addon'; addon.appendChild(gw); frag.appendChild(addon); }

    // coupon block (owned input + Apply; applies to the session, carries to checkout)
    var coupon = document.createElement('div'); coupon.className = 'tlsk-sum-coupon';
    coupon.innerHTML =
      '<div class="tlsk-sum-coupon__row">' +
        '<span class="tlsk-sum-coupon__ic">' + SVG_TAG + '</span>' +
        '<input type="text" class="tlsk-sum-code" placeholder="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
        '<button type="button" class="tlsk-sum-apply" data-tlsk-coupon-apply>Apply</button>' +
      '</div>' +
      '<div class="tlsk-sum-applied" hidden></div>';
    frag.appendChild(coupon);

    // totals placeholder
    var tot = document.createElement('div'); tot.className = 'tlsk-ct'; frag.appendChild(tot);

    // checkout: relocate the native checkout button group into the card (keeps it inside the form)
    var grp = col.querySelector('.t4s-btn-group__checkout-update');
    if (grp) frag.appendChild(grp);

    // trust
    var trust = document.createElement('div'); trust.className = 'tlsk-cart-trust';
    trust.innerHTML =
      '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Secure checkout</span>' +
      '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9 9 0 0 0-7 3.3"/><path d="M3 4v4h4"/></svg>30-day returns</span>' +
      '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Free shipping</span>';
    frag.appendChild(trust);

    // wipe leftover native summary nodes, then mount our card
    col.innerHTML = '';
    col.appendChild(frag);
    document.body.classList.add('tlsk-cartpage-on');
    return col;
  }

  function renderTotals(cart) {
    var col = summaryCol(); if (!col) return;
    var box = col.querySelector('.tlsk-ct'); if (!box) return;
    var info = discInfo(cart);
    var html = '<div class="tlsk-ct__row"><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>';
    if (info) html += '<div class="tlsk-ct__row is--disc"><span>Discount · ' + info.code + '</span><span>−' + money(info.amt) + '</span></div>';
    html += '<div class="tlsk-ct__row"><span>Shipping</span><span' + (FREE_SHIP ? ' class="tlsk-ct__free"' : '') + '>' + (FREE_SHIP ? 'Free' : 'At checkout') + '</span></div>';
    html += '<div class="tlsk-ct__total"><span>Total</span><span>' + (cart.total_discount > 0 ? '<s>' + money(cart.original_total_price) + '</s> ' : '') + '<b>' + money(cart.total_price) + '</b></span></div>';
    setHTML(box, html);

    // coupon: applied chip vs input
    var applied = col.querySelector('.tlsk-sum-applied');
    var row = col.querySelector('.tlsk-sum-coupon__row');
    if (applied && row) {
      if (info) {
        setHTML(applied, '<span class="tlsk-sum-applied__tx"><b>' + info.code + '</b> applied — ' + info.label + '</span><button type="button" class="tlsk-sum-applied__x" data-tlsk-coupon-remove aria-label="Remove">✕</button>');
        applied.hidden = false; row.style.display = 'none';
      } else { applied.hidden = true; row.style.display = ''; }
    }
  }

  // add a Save button to the order note (cart page has none — it only saves on checkout otherwise)
  function ensureNoteSave() {
    var ta = document.querySelector('#CartSpecialInstructions'); if (!ta) return;
    if (document.querySelector('.tlsk-note-save')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'tlsk-note-save'; b.setAttribute('data-tlsk-note-save', ''); b.textContent = 'Save';
    // wrap the textarea + button so they can sit side-by-side on mobile/tablet
    var row = document.createElement('div'); row.className = 'tlsk-note-row';
    ta.parentNode.insertBefore(row, ta);
    row.appendChild(ta);
    row.appendChild(b);
  }
  function saveNote(val) {
    var b = document.querySelector('.tlsk-note-save'); if (b) { b.textContent = '…'; b.disabled = true; }
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: val }) })
      .catch(function () {})
      .then(function () { if (b) { b.textContent = 'Saved ✓'; b.classList.add('is--saved'); b.disabled = false; setTimeout(function () { b.textContent = 'Save'; b.classList.remove('is--saved'); }, 1900); } });
  }

  function applyCoupon(code) {
    if (!code) return;
    var b = document.querySelector('.tlsk-sum-apply'); if (b) { b.textContent = '…'; b.disabled = true; }
    fetch('/discount/' + encodeURIComponent(code), { headers: { 'X-Requested-With': 'fetch' } })
      .catch(function () {}).then(function () { window.location.reload(); });
  }
  function removeCoupon() {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) })
      .catch(function () {}).then(function () { try { localStorage.removeItem('CartDiscountcode'); } catch (e) {} window.location.reload(); });
  }


  // Minimum sipariş kapısı — mini-cart'takinin cart sayfası karşılığı.
  // Eşik ve muafiyet hesabı TLSK_MIN_ORDER'dan gelir (tlsk-cart-rewards.js); kural
  // burada yeniden yazılmaz, yoksa iki dosya zamanla birbirinden sapar.
  function applyMinOrderGate(cart) {
    var col = summaryCol(); if (!col) return;
    var api = window.TLSK_MIN_ORDER;
    var grp = col.querySelector('.t4s-btn-group__checkout-update');
    var btn = col.querySelector('.t4s-btn__checkout');
    var bar = col.querySelector('.tlsk-min-order');

    if (!api || !api.min) {                       // rewards kapalı → kural yok
      if (bar) bar.remove();
      if (btn) { btn.disabled = false; btn.classList.remove('is--blocked'); btn.setAttribute('aria-disabled', 'false'); }
      return;
    }

    var st = api.evaluate(cart);
    if (btn) {
      if (btn.tagName === 'BUTTON') btn.disabled = st.blocked;
      btn.setAttribute('aria-disabled', st.blocked ? 'true' : 'false');
      btn.classList.toggle('is--blocked', st.blocked);
    }

    if (!st.blocked) { if (bar) bar.remove(); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'tlsk-min-order';
      if (grp && grp.parentNode) grp.parentNode.insertBefore(bar, grp);
      else col.appendChild(bar);
    }
    setHTML(bar,
      '<div class="tlsk-mo__track"><i style="--mopct:' + st.pct.toFixed(1) + '%"></i></div>' +
      '<p class="tlsk-mo__msg"><b>' + api.money(st.needed) + '</b> more to unlock checkout</p>');
  }

  // Bedava hediye ödülü — kaynak (eşik + ürün id) mini-cart section'ının render ettiği
  // window.TLSK_REWARDS'tan okunur (bug fix 2026-09-13). Ayrı bir eşik yazmıyoruz:
  // mini_cart section /cart sayfasında render edilmediği için o config burada yok,
  // tek seferlik /?section_id=mini_cart isteğiyle çekip önbelleğe alıyoruz.
  var GIFT_CFG = null; // { pid, at } | false (yüklendi ama ödül kapalı/yok)
  function loadGiftCfg() {
    if (GIFT_CFG !== null) return Promise.resolve(GIFT_CFG);
    return fetch('/?section_id=mini_cart').then(function (r) { return r.text(); }).then(function (html) {
      try {
        var m = html.match(/window\.TLSK_REWARDS\s*=\s*(\{[\s\S]*?\});/);
        if (m) {
          var cfg = (new Function('return ' + m[1]))();
          var giftTier = (cfg.tiers || []).filter(function (t) { return t.type === 'gift'; })[0];
          var pid = String(cfg.giftProductId || '');
          if (pid && giftTier) GIFT_CFG = { pid: pid, at: giftTier.at };
        }
      } catch (e) {}
      if (GIFT_CFG === null) GIFT_CFG = false;
      return GIFT_CFG;
    }).catch(function () { GIFT_CFG = false; return GIFT_CFG; });
  }

  // Ödül eşiğinin altına düşülünce hediyeyi sunucudan siler ve sayfayı tazeler — bu
  // dosyanın kendi decrease-qty-to-zero akışıyla aynı desen (window.location.reload()).
  // /cart sayfasından hediye EKLEMİYOR (o akış sadece mini-cart drawer'da kalıyor);
  // burada tek amaç hediyenin sepette YALNIZ BAŞINA kalmasını önlemek.
  function reconcileGift(cart) {
    return loadGiftCfg().then(function (g) {
      if (!g) return false;
      var giftItem = cart.items.filter(function (i) { return String(i.product_id) === g.pid; })[0];
      if (!giftItem) return false;
      var qualifies = cart.items_subtotal_price >= g.at;
      if (qualifies) return false;
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: giftItem.key, quantity: 0 }) })
        .then(function () { window.location.reload(); return true; })
        .catch(function () { return false; });
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        reconcileGift(cart).then(function (reloading) {
          if (reloading) return;   // page is about to reload with the corrected cart
          buildCard(); renderTotals(cart); ensureNoteSave(); applyMinOrderGate(cart);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-tlsk-coupon-apply]');
    if (a) { e.preventDefault(); var i = document.querySelector('.tlsk-sum-code'); applyCoupon(i && i.value ? i.value.trim() : ''); return; }
    var r = e.target.closest('[data-tlsk-coupon-remove]');
    if (r) { e.preventDefault(); removeCoupon(); return; }
    var ns = e.target.closest('[data-tlsk-note-save]');
    if (ns) { e.preventDefault(); var ta = document.querySelector('#CartSpecialInstructions'); saveNote(ta ? ta.value : ''); return; }
  }, false);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.classList && e.target.classList.contains('tlsk-sum-code')) { e.preventDefault(); applyCoupon(e.target.value.trim()); }
  }, false);


  // Cart sayfasında son adedin eksi tuşu: tema minimumun altına inemediği için
  // hiçbir şey yapmıyordu. Satırı Cart AJAX API ile kaldırıp sayfayı tazeliyoruz
  // (temanın kendi kaldırma bağlantısı da zaten navigasyon yapıyor).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-decrease-qty]');
    if (!btn || !btn.closest('.t4s-cartPage__form')) return;
    var wrap = btn.closest('[data-quantity-wrapper]') || btn.parentElement;
    var inp = wrap && wrap.querySelector('[data-quantity-value]');
    if (!inp) return;
    var v = parseInt(inp.value || inp.getAttribute('data-current-qty') || '1', 10);
    var min = parseInt(inp.getAttribute('min') || '1', 10);
    if (v > Math.max(1, isNaN(min) ? 1 : min)) return;      // normal azaltma → temaya bırak
    e.preventDefault(); e.stopImmediatePropagation();
    var key = inp.getAttribute('data-id');
    if (!key) { var rm = btn.closest('tr, li, .t4s-cart-item'); rm = rm && rm.querySelector('[data-cart-remove]'); key = rm && rm.getAttribute('data-id'); }
    if (!key) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }, true);

  function debouncedRefresh() { clearTimeout(tmr); tmr = setTimeout(refresh, 220); }

  // build the card structure ASAP (before the cart.js round-trip) to avoid a layout flash
  function start() {
    try { buildCard(); ensureNoteSave(); } catch (e) {}
    refresh();
    // re-render the totals whenever the cart items change (qty +/- must update the summary instantly)
    var form = document.querySelector('.t4s-cartPage__form');
    if (form) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.closest && t.closest('.t4s-order-4, .cart_actions')) continue; // ignore our own card + note writes
          debouncedRefresh(); return;
        }
      });
      mo.observe(form, { childList: true, subtree: true, characterData: true });
    }
    // fallback: after any qty control click, re-pull totals once the theme's AJAX settles
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-quantity-selector], [data-increase-qty], [data-decrease-qty]')) {
        setTimeout(refresh, 500); setTimeout(refresh, 1100);
      }
    }, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
